import { useState, useEffect } from 'react'
import Slider from 'react-slick'
import supabase from '../lib/supabase'
import Modal from './common/Modal'
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

export default function ProjectsShowcaseCarousel() {
  const [projects, setProjects] = useState([])
  const [loading, setLoading] = useState(true)
  const [selectedProject, setSelectedProject] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)

  useEffect(() => {
    fetchProjects()
  }, [])

  const fetchProjects = async () => {
    try {
      const { data, error } = await supabase
        .from('codevaro_projects')
        .select(`
          *,
          codevaro_services (
            id,
            title
          )
        `)
        .eq('is_featured', true)
        .limit(8)
        .order('created_at', { ascending: false })

      if (error) throw error
      
      // If no projects from database, use fallback data
      if (!data || data.length === 0) {
        setProjects(getFallbackProjects())
      } else {
        setProjects(data)
      }
    } catch (error) {
      console.error('Error fetching projects:', error)
      // Use fallback data on error
      setProjects(getFallbackProjects())
    } finally {
      setLoading(false)
    }
  }

  const getFallbackProjects = () => [
    {
      id: 1,
      title: "E-Commerce Platform",
      description: "Ολοκληρωμένη πλατφόρμα e-commerce με προηγμένες λειτουργίες πληρωμών και διαχείρισης αποθέματος.",
      full_description: "Αυτό το project περιλάμβανε την ανάπτυξη μιας πλήρους πλατφόρμας e-commerce από το μηδέν. Υλοποιήσαμε προηγμένες λειτουργίες όπως real-time inventory management, πολλαπλές μεθόδους πληρωμής, automated email marketing, και analytics dashboard. Το αποτέλεσμα ήταν αύξηση των πωλήσεων κατά 250% στους πρώτους 6 μήνες.",
      image_url: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      client_name: "TechStore Ltd",
      project_url: "https://example.com",
      codevaro_services: [
        { id: 1, title: "Web Development" },
        { id: 2, title: "E-Commerce Solutions" }
      ]
    },
    {
      id: 2,
      title: "Corporate Website",
      description: "Σύγχρονη εταιρική ιστοσελίδα με responsive design και CMS για εύκολη διαχείριση περιεχομένου.",
      full_description: "Δημιουργήσαμε μια εντυπωσιακή εταιρική ιστοσελίδα που αντικατοπτρίζει την ταυτότητα της επιχείρησης. Το project περιλάμβανε custom design, responsive development, SEO optimization, και ένα εύχρηστο CMS. Η ιστοσελίδα πέτυχε 300% αύξηση στα leads και σημαντική βελτίωση στο brand awareness.",
      image_url: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      client_name: "Business Pro",
      project_url: "https://example.com",
      codevaro_services: [
        { id: 1, title: "Web Development" },
        { id: 3, title: "SEO Optimization" }
      ]
    },
    {
      id: 3,
      title: "Mobile Banking App",
      description: "Ασφαλής εφαρμογή mobile banking με προηγμένες λειτουργίες και user-friendly interface.",
      full_description: "Αναπτύξαμε μια πλήρως ασφαλή mobile banking εφαρμογή με biometric authentication, real-time transactions, και intuitive UI/UX. Η εφαρμογή υποστηρίζει όλες τις βασικές τραπεζικές λειτουργίες και έχει πετύχει 99.9% uptime με εξαιρετικές αξιολογήσεις από τους χρήστες.",
      image_url: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      client_name: "FinTech Solutions",
      project_url: "https://example.com",
      codevaro_services: [
        { id: 4, title: "Mobile App Development" },
        { id: 5, title: "Security Solutions" }
      ]
    },
    {
      id: 4,
      title: "Digital Marketing Campaign",
      description: "Επιτυχημένη καμπάνια digital marketing που αύξησε τις πωλήσεις κατά 300% σε 6 μήνες.",
      full_description: "Σχεδιάσαμε και εκτελέσαμε μια ολοκληρωμένη καμπάνια digital marketing που περιλάμβανε SEO, SEM, Social Media Marketing, και Content Marketing. Η στρατηγική μας στόχευσε στο σωστό κοινό και πέτυχε εντυπωσιακά αποτελέσματα: 300% αύξηση πωλήσεων, 500% αύξηση traffic, και 250% βελτίωση του ROI.",
      image_url: "https://images.unsplash.com/photo-1432888622747-4eb9a8efeb07?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      client_name: "Growth Company",
      project_url: "https://example.com",
      codevaro_services: [
        { id: 6, title: "Digital Marketing" },
        { id: 3, title: "SEO Optimization" }
      ]
    }
  ]

  const handleLearnMore = (project) => {
    setSelectedProject(project)
    setIsModalOpen(true)
  }

  const handleViewProject = (project) => {
    // Open popup with project details instead of opening URL directly
    setSelectedProject(project)
    setIsModalOpen(true)
  }

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  }

  if (loading) {
    return (
      <div className="flex justify-center items-center py-20">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
      </div>
    )
  }

  return (
    <section id="projects" className="bg-gradient-to-br from-gray-50 to-gray-100 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Τα Έργα Μας
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ανακαλύψτε μερικά από τα επιτυχημένα projects που έχουμε υλοποιήσει για τους πελάτες μας
          </p>
        </div>

        <Slider {...settings} className="projects-showcase">
          {projects.map((project, index) => (
            <div key={project.id} className="px-4">
              <div className="bg-white rounded-2xl shadow-xl overflow-hidden transform hover:scale-105 transition-all duration-300 hover:shadow-2xl">
                {/* Project Image */}
                <div className="relative h-64 overflow-hidden">
                  {project.image_url ? (
                    <img
                      src={project.image_url}
                      alt={project.title}
                      className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                    />
                  ) : (
                    <div className="w-full h-full bg-gradient-to-br from-purple-400 to-blue-600 flex items-center justify-center">
                      <div className="text-white text-6xl opacity-30">
                        🚀
                      </div>
                    </div>
                  )}
                  
                  {/* Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                  
                  {/* Client Badge */}
                  {project.client_name && (
                    <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-sm font-medium text-gray-800">
                      {project.client_name}
                    </div>
                  )}
                </div>

                {/* Project Content */}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {project.title}
                  </h3>
                  
                  <p className="text-gray-600 mb-4 line-clamp-3">
                    {project.description}
                  </p>

                  {/* Services Used */}
                  {project.codevaro_services && project.codevaro_services.length > 0 && (
                    <div className="mb-4">
                      <div className="text-sm font-medium text-gray-700 mb-2">Υπηρεσίες που χρησιμοποιήθηκαν:</div>
                      <div className="flex flex-wrap gap-2">
                        {project.codevaro_services.map((service) => (
                          <span
                            key={service.id}
                            className="px-2 py-1 bg-purple-100 text-purple-800 text-xs rounded-full font-medium"
                          >
                            {service.title}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Action Buttons */}
                  <div className="flex gap-3">
                    <button
                      onClick={() => handleViewProject(project)}
                      className="flex-1 bg-purple-600 text-white text-center py-2 px-4 rounded-lg hover:bg-purple-700 transition-colors text-sm font-medium"
                    >
                      Δείτε το Project
                    </button>
                    <button 
                      onClick={() => handleLearnMore(project)}
                      className="flex-1 border border-purple-600 text-purple-600 py-2 px-4 rounded-lg hover:bg-purple-50 transition-colors text-sm font-medium"
                    >
                      Μάθετε Περισσότερα
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>

        {/* Project Details Modal */}
        <Modal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          title={selectedProject?.title || ''}
          size="lg"
        >
          {selectedProject && (
            <div className="space-y-6">
              {selectedProject.image_url && (
                <img
                  src={selectedProject.image_url}
                  alt={selectedProject.title}
                  className="w-full h-64 object-cover rounded-lg"
                />
              )}
              
              <div className="flex items-center gap-4">
                {selectedProject.client_name && (
                  <span className="px-3 py-1 bg-purple-100 text-purple-800 text-sm rounded-full">
                    Πελάτης: {selectedProject.client_name}
                  </span>
                )}
              </div>

              <p className="text-gray-700 leading-relaxed text-lg">
                {selectedProject.full_description || selectedProject.description}
              </p>

              {/* Services Used */}
              {selectedProject.codevaro_services && selectedProject.codevaro_services.length > 0 && (
                <div>
                  <h4 className="font-semibold text-gray-900 mb-3">Υπηρεσίες που χρησιμοποιήθηκαν:</h4>
                  <div className="flex flex-wrap gap-2">
                    {selectedProject.codevaro_services.map((service) => (
                      <span
                        key={service.id}
                        className="px-3 py-1 bg-purple-100 text-purple-800 text-sm rounded-full font-medium"
                      >
                        {service.title}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              <div className="flex gap-4 pt-4">
                {selectedProject.project_url && (
                  <a
                    href={selectedProject.project_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-1 bg-purple-600 text-white text-center py-3 px-6 rounded-lg hover:bg-purple-700 transition-colors font-semibold"
                  >
                    Επισκεφθείτε το Project
                  </a>
                )}
                <button className="flex-1 border border-purple-600 text-purple-600 py-3 px-6 rounded-lg hover:bg-purple-50 transition-colors font-semibold">
                  Ζητήστε Παρόμοιο Project
                </button>
              </div>
            </div>
          )}
        </Modal>
      </div>
    </section>
  )
}